<template>
	<div class="goods">
	<v-head :title="title"></v-head>
		<template>
           <div class="warmTips" v-if="hotelData && !hotelData.length">
              <img src="../../assets/images/404.png"/>
              <span>没有找到相应内容哦</span>
            </div>
			<div v-for="(item,index) in hotelData" :key="index">
			<van-card @click="toHotel(item)"
					:num="item.leftStandard"
					:price="item.dipositStandard"
					desc="标准押金"
					:title="item.name"
					thumb=""
			/>
			</div>
		</template>
	</div>
</template>
<script>
import { Card,Button } from "vant";
import {getHotels} from "@/api/dictionary";
import vHead from "../../components/Subhead.vue";
export default {
  data() {
    return {
		hotelData: [],
		title:"酒店预订"
    };
  },
  components: {
    vHead,
    [Card.name]: Card,
    [Button.name]: Button,
  },
  computed:{
  	meetingId(){
  	return this.$route.query&&this.$route.query.meetingId;
  	}
  },
  methods: {
	  getHotels() {
		  let params = {
			  "meetingId":this.meetingId
		  };

		  getHotels(params).then(res => {
			  if (res.success) {
				  this.hotelData = res.result;
			  }
		  });
	  },
	  toHotel(item){
	  	let query = {"id":item.id,"meetingId":item.meetingId}
	  	this.$router.push({path:"/hotel",query:query});
	  }
  },
	mounted() {
  		this.getHotels();
	}
};
</script>

<style  lang="less" scoped>
body{ background: #eee; }
.means{
 padding:20px 13px 15px 13px; background:url(../../assets/images/hy_bg.jpg); background-size: 100%; overflow:hidden;
.van-button{ float: right; background: #fff; color: #378be1; border:none; line-height: 26px; height: 35px;  margin-top: 8px;}
}
.portrait{ width:15%; float:left;}
.means_name{float:left; font-size:14px; color:#fff; margin-top:5px;line-height:24px; margin-left:10px;}
.more{ float:right; margin-top:25px; color:#fff;}
.means_top{ overflow: hidden; }
.mean_bottom{ font-size: 14px; color: #fff;  margin-top: 15px;
   .left_c{ float: left; line-height: 26px;}
}

.menu { padding:15px 0; border-bottom: #f2f2f2 8px solid;
.van-col{ text-align: center; 
           img{ display: block; width: 45%; margin:0 auto; }
           span{ font-size: 13px;  margin-top:10px; display:block;}
	    }
 }
.meeting_box{ 
	padding:15px; 
	img{ width: 100%; max-height: 5.2rem}
	li{border-bottom:#dfdfdf solid 1px; padding-bottom: 15px; position: relative; margin-bottom: 15px;}
	.van-button{ float: right; background: #378be1; color: #fff; border:none; line-height: 26px; height: 30px;  margin-top: 8px;
		position: absolute; bottom:15px; right:0px;}
    
}
.fonts{ font-size: 13px; line-height: 24px; margin-top: 10px;}
/deep/.van-card__content{ font-size:16px; }
/deep/.van-card{ background: #fff; border-bottom: 8px solid #f3f3f3;  }
/deep/.van-card__content>div{ padding-top: 10px; }
/deep/.van-card__title{ padding: 5px 0;}
/deep/.van-card__desc{ font-size:14px; margin-top:15px }
</style>